import { ToggleButton, ToggleButtonGroup } from '@tunasong/ui-lib'
import type { FC, KeyboardEvent } from 'react'
import styles from './chat-filter.module.css'

export type ChatFilter = 'all' | 'tasks' | 'resolved'

/** T8–T10 */
const labels: Record<ChatFilter, string> = { all: 'All', tasks: 'Tasks', resolved: 'Resolved' }

export interface ChatFilterGroupProps {
  filters: ChatFilter[]
  value: ChatFilter
  onChange(filter: ChatFilter): void
}

/**
 * What Chat shows (chat tasks M2.4, GH #3041): a group named "Show" (T18). The arrow keys move along it and choose,
 * wrapping at the ends (spec §6).
 */
export const ChatFilterGroup: FC<ChatFilterGroupProps> = props => {
  const { filters, value, onChange } = props

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[event.key]
    if (!step) {
      return
    }
    event.preventDefault()
    const next = filters[(filters.indexOf(value) + step + filters.length) % filters.length]
    if (!next) {
      return
    }
    onChange(next)
    event.currentTarget.querySelector<HTMLButtonElement>(`[data-filter="${next}"]`)?.focus()
  }

  return (
    <ToggleButtonGroup
      className={styles.filter}
      aria-label="Show"
      size="small"
      exclusive={true}
      value={value}
      onKeyDown={handleKeyDown}
    >
      {filters.map(filter => (
        <ToggleButton key={filter} value={filter} data-filter={filter} onClick={() => onChange(filter)}>
          {labels[filter]}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  )
}
